import { ModuleContent } from '../contract';

export type WelcomeGuideButtonModuleContent = {
	buttonText: string;
	buttonLink: string;
};

export function isWelcomeGuideButtonModuleContent(content: ModuleContent): content is WelcomeGuideButtonModuleContent {
	const welcomeGuideContent = content as Partial<WelcomeGuideButtonModuleContent>;
	return typeof welcomeGuideContent.buttonText === 'string' && typeof welcomeGuideContent.buttonLink === 'string';
}

export function getWelcomeGuideButtonModuleIndexableText(content: ModuleContent): string {
	if (!isWelcomeGuideButtonModuleContent(content)) return '';
	return [content.buttonText, content.buttonLink].filter(Boolean).join(' ').trim();
}